import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import UserService from "./user.service";

const API_ADMIN_URL = AdminService.getBaseUrl() + "/api/v1/admin"

class BenchmarkCompanyService {
  async buildBenchmarkMapping  (callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_ADMIN_URL + "/build-benchmark-company-mapping", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("BenchmarkCompanyService.getBenchmarkExclusionList", error, "admin", chartApp);
      });
  }
  async getBenchmarkExclusionList(clientCode, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("clientCode", clientCode);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_ADMIN_URL + "/get-benchmark-exclusion-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("BenchmarkCompanyService.getBenchmarkExclusionList", error, "admin", chartApp);
      });
  }
  async saveBenchmarkExclusionList(clientCode, list, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("clientCode", clientCode);
    params.append("userId", UserService.getUserId());
    params.append("list", list);
    await axios
      .post(API_ADMIN_URL + "/save-benchmark-exclusion-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("BenchmarkCompanyService.saveBenchmarkExclusionList", error, "admin", chartApp);
      });
  }
  async applyBenchmarkExclusionList(clientCode, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("clientCode", clientCode);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_ADMIN_URL + "/apply-benchmark-exclusion-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("BenchmarkCompanyService.applyBenchmarkExclusionList", error, "admin", chartApp);
      });
  }

}

export default new BenchmarkCompanyService();
